"use strict";

exports.__esModule = true;
exports.viewModesMap = exports.viewModes = exports.sliderSettings = exports.sliderDirectionMap = exports.filtersType = exports.filtersMap = exports.filtersKeys = void 0;
var _commonMediaQuery = require("@mmc/common-media-query");
var filtersType = {
  TEXT: 'text',
  MULTIPLE: 'multiple'
};
exports.filtersType = filtersType;
var filtersMap = {
  ZIP_CODE: 'zipCode',
  VEHICLE: 'vehicles',
  UTM: 'utm_medium',
  OFFER_TYPE: 'offerTypes',
  MODEL_YEAR: 'modelYear',
  REGION: 'region'
};
exports.filtersMap = filtersMap;
var filtersKeys = Object.values(filtersMap);
exports.filtersKeys = filtersKeys;
var viewModesMap = {
  GRID: 'grid',
  SLIDER: 'slider'
};
exports.viewModesMap = viewModesMap;
var viewModes = Object.values(viewModesMap);
exports.viewModes = viewModes;
var sliderDirectionMap = {
  PREV: 'prev',
  NEXT: 'next'
};
exports.sliderDirectionMap = sliderDirectionMap;
var sliderSettings = {
  infinite: false,
  dots: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 3,
  touchThreshold: 100,
  responsive: [{
    breakpoint: _commonMediaQuery.BREAKPOINTS.sm.MAX,
    settings: {
      arrows: false,
      slidesToScroll: 2,
      slidesToShow: 2.4
    }
  }, {
    breakpoint: _commonMediaQuery.BREAKPOINTS.xs.MAX,
    settings: {
      arrows: false,
      slidesToScroll: 1,
      slidesToShow: 1.2
    }
  }]
};
exports.sliderSettings = sliderSettings;